import { createContext, useContext, useState } from 'react'

const ModalContext = createContext()

export const useModal = () => useContext(ModalContext)

export const ModalProvider = ({ children }) => {
	const [isProjectModalOpen, setIsProjectModalOpen] = useState(false)
	const [isContactModalOpen, setIsContactModalOpen] = useState(false)

	return (
		<ModalContext.Provider
			value={{ isProjectModalOpen, setIsProjectModalOpen, isContactModalOpen, setIsContactModalOpen }}
		>
			{children}
		</ModalContext.Provider>
	)
}
